module.exports = __webpack_public_path__ + "public/Icons/insta.png?4273da40";